/* eslint no-console: "off",  */

function retry(numberOfRetries, isRetriable, action, _count) {
  const count = _count || 0;
  return action().catch(function(err) {
    if (count < numberOfRetries && isRetriable(err)) {
      return new Promise(function(resolve) {
        setTimeout(resolve, Math.min(Math.pow(2, count) * 150, 30000));
      }).then(function() {
        return retry(numberOfRetries, isRetriable, action, count + 1);
      });
    } else {
      throw err;
    }
  });
}

function authenticate(authClient) {
  const promise = retry(
    10,
    err => {
      // TODO: Error states are not stored as such any longer
      console.error('Auth Retry Error', err);
      return err.name !== window.authClient.errorNames.INVALID_AUTHENTICATION;
    },
    function() {
      return authClient.getAuth();
    }
  ).then(result => {
    return result;
  });

  promise.catch(() => {
    authClient
      .getAuth()
      .then(result => {
        console.log(result);
      })
      .catch(err => {
        console.log('Auth Error', err);
        if (err.code === 'LOGIN_REQUIRED') {
          // Here might be a good time to check if any state needs to be saved before redirecting
          authClient.startInteractiveAuth();
        } else if (err.code === 'TIMED_OUT') {
          // Timeout error handling here, maybe retry in a moment?
        } else {
          // Unexpected/Undocumented error
          // At this time maybe track these errors and report back to core domain
        }
      });
  });

  return promise;
}

export default {
  authenticate
};



// WEBPACK FOOTER //
// ./src/components/reusable/Authenticator.js